<!-- eslint-disable -->
<template>

    <div>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Архив категорий</h3>
                    </div>
                    <div class="card-body">
                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                        <div v-else>
                            <h3 class="card-title font-weight-bolder text-dark">Категории</h3>
                            <b-list-group >

                                <template v-for="(category, i) in trashed.categories">
                                    <div v-bind:key="i">
                                    <b-list-group-item class="d-flex justify-content-between align-items-center" variant="primary">
                                        <a> {{category.name}}</a>
                                        <b-link @click="restoreCategory(category.id)" v-b-tooltip.hover title="Восстановить категорию" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-trash-restore"></i></b-link>
                                    </b-list-group-item>
                                    </div>
                                </template>

                            </b-list-group>

                            <h3 class="card-title font-weight-bolder text-dark mt-10">Подкатегории</h3>

                            <b-list-group >
                                <template v-for="(category, i) in trashed.subCategories">
                                    <div v-bind:key="i">
                                        <b-list-group-item class="d-flex justify-content-between align-items-center" variant="primary">
                                            <a> {{category.name}}</a>
                                            <b-link @click="restoreSubCategory(category.id)" v-b-tooltip.hover title="Восстановить категорию" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-trash-restore"></i></b-link>
                                        </b-list-group-item>
                                    </div>
                                </template>
                            </b-list-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {GET_CATEGORIES_TRASHED} from "@/core/services/store/categories.module";
    import {SET_ALERT} from "@/core/services/store/alert.module";
    import {RESTORE_CATEGORY, RESTORE_SUB_CATEGORY} from "../../../core/services/store/categories.module";
    export default {
        name: "Categories",
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Категории товаров" }]);
            this.$store.dispatch(GET_CATEGORIES_TRASHED);
        },
        computed: {
            ...mapGetters({
                trashed: 'gettersTrashedCategories',
                load: 'getCategoryLoad'
            }),

        },

        methods:{

            getCategories(){
                this.$store.dispatch(GET_CATEGORIES_TRASHED);
            },

            restoreCategory(id){
                this.$store.dispatch(RESTORE_CATEGORY, id)
                    .then(() => {
                        this.getCategories();
                        this.showAlert('Категория успешно восстановла', 'success');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка восстановления', 'danger', 'toast');
                    })
            },

            restoreSubCategory(id){
                this.$store.dispatch(RESTORE_SUB_CATEGORY, id)
                    .then(() => {
                        this.getCategories();
                        this.showAlert('Категория успешно восстановла', 'success');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка восстановления', 'danger', 'toast');
                    })
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

        }

    }
</script>

<style scoped>

    tr{
        border-bottom: 1px #8099ff solid;
    }

    tr.category {
        background: #f7fbff;
    }


    .badge-primary i{
        color: #ffffff;
    }

    .badge-pill{
        border-radius: 0.3rem;
    }

</style>